import { AfterViewInit, Directive, ElementRef } from '@angular/core';
@Directive({
  selector: '[axis-truncate]',
})
export class AxisTruncateDirective implements AfterViewInit {
  private el: HTMLElement;
  private actualElement;

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.hasOwnProperty('nativeElement')
      ? this.elementRef.nativeElement
      : this.elementRef;
  }

  ngAfterViewInit(): void {
    this.checkTruncate();
    this.addTooltip();
  }

  getRealElement(e) {
    if (e.nodeName === 'TD') { return e; }
    if (e.hasOwnProperty('children') && e.children.length > 0) {
      return e.children[0];
    }
    return e;
  }

  checkTruncate(): void {
    if (!this.actualElement) {
      this.actualElement = this.getRealElement(this.el);
      this.actualElement.classList.add('axis-truncate-generic');
      this.actualElement.addEventListener('mouseenter', this.addTooltip.bind(this));
    }
  }

  addTooltip() {
    if (this.isTruncated(this.actualElement)) {
      this.el.classList.add('axis-truncate-should-tooltip');
      this.el.classList.remove('axis-truncate-should-not-tooltip');
    } else {
      this.el.classList.remove('axis-truncate-should-tooltip');
      this.el.classList.add('axis-truncate-should-not-tooltip');
    }
  }

  isTruncated(e) {
    if (e.nodeName === 'TD') { return e.offsetWidth < e.scrollWidth; }
    return e.offsetWidth < e.scrollWidth || e.offsetHeight < e.scrollHeight;
  }
}
